<template>
  <v-btn
    class="subcategory-button mb-3"
    elevation="10"
    fab
    rounded
    x-large
    @click="emitClicked"
  >
    <div class="d-flex flex-column align-center">
      <v-icon
        v-if="icon"
        :color="color"
        >{{ icon }}</v-icon
      ><span>{{ text }}</span>
    </div></v-btn
  >
</template>

<script>
export default {
  name: 'SubcategoryButton',
  props: {
    text: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: false,
    },
    color: {
      type: String,
      required: false,
      default: () => null,
    },
  },
  methods: {
    emitClicked() {
      this.$store.dispatch('repairTickets/setSelectedSubcategory', this.text);
    },
  },
};
</script>

<style lang="scss">
.subcategory-button {
  width: 100% !important;
  height: 100px !important;
}
</style>
